import React from "react";
import { useShow } from "@refinedev/core";
import { Show, TagField } from "@refinedev/antd";
import { PERMISSION_ONE_QUERY } from "./queries";
import { Typography, Space } from "antd";
const { Text, Title } = Typography;

interface IPermission {
  id: string;
  organizationalRoles: string[];
  resources: string[];
  actions: string[];
}

export const ShowPermission: React.FC = () => {
  const { query } = useShow<IPermission>({
    resource: "permissions",
    meta: {
      gqlQuery: PERMISSION_ONE_QUERY,
    },
  });

  const { data, isLoading } = query;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Resources</Title>
      <Space wrap>
        {record?.resources?.map((r) => (
          <TagField key={r} value={r === '*' ? 'All' : r} />
        ))}
      </Space>

      <Title level={5}>Actions</Title>
      <Space wrap>
        {record?.actions?.map((a) => (
          <TagField key={a} value={a === '*' ? 'All' : a} />
        ))}
      </Space>

      <Title level={5}>Organizational Roles</Title>
      <Space wrap>
        {record?.organizationalRoles?.map((role) => (
          <TagField key={role} value={role} />
        ))}
      </Space>

      <Title level={5}>ID</Title>
      <Text>{record?.id}</Text>
    </Show>
  );
};
